/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc3dhbnRkaGF5YWwvRGVza3RvcC9Qcm9qZWN0cy9zZW5pb3JKYWNrZXRzL3NyYy9hcHAvZnJvbnQtamFja2V0L2Zyb250LWphY2tldC5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL2phc3dhbnRkaGF5YWwvRGVza3RvcC9Qcm9qZWN0cy9zZW5pb3JKYWNrZXRzL3NyYy9hcHAvZnJvbnQtamFja2V0L2Zyb250LWphY2tldC5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/$$_gendir/app/front-jacket/front-jacket.component.css.shim.ngstyle.ts